export const familyKeys = {
  all: ['family'] as const,
  lists: () => [...familyKeys.all, 'list'] as const,
  list: (filters?: unknown) => [...familyKeys.lists(), filters] as const,
  details: () => [...familyKeys.all, 'detail'] as const,
  detail: (id: string) => [...familyKeys.details(), id] as const,
  members: (familyId: string) => [...familyKeys.all, 'members', familyId] as const,
  member: (memberId: string) => [...familyKeys.all, 'member', memberId] as const,
  invitations: (familyId: string) => [...familyKeys.all, 'invitations', familyId] as const,
  settings: (familyId: string) => [...familyKeys.all, 'settings', familyId] as const,
  accounts: (memberId: string) => [...familyKeys.all, 'accounts', memberId] as const,
};
